import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';

/**
 * Generated class for the ClinicopenroomPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-clinicopenroom',
  templateUrl: 'clinicopenroom.html',
})
export class ClinicopenroomPage {
  title = ''
  clinicroomTab: string = 'current'
  roomdata: any;
  _did: any;
  beaconstoday = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController) {
    //debugger
    this.roomdata = navParams.get('d')
    this._did = navParams.get('did')
    this.title = navParams.get('d').room;
  }

  ionViewDidLoad() {

    for (var o = 0; o < this.gn.Organisations.length; o++) {
      this.gn.Organisations[o].expand = true;
    }

    var _that = this
    setTimeout(function () {
      var el = <HTMLInputElement>document.getElementById('header-clinicroom-open')
      var el1 = <HTMLInputElement>el.getElementsByClassName('toolbar-background')[0]
      el1.style.backgroundColor = _that.roomdata.color
      //debugger
    }, 100)

    console.log('ionViewDidLoad ClinicopenroomPage');
    this.getBeaconsToday();
  }

  sec2str3(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  getBeaconsToday() {
    var _that = this;
    this.gn._Post('/api/gn/getbeaconstoday', { cid: this.gn.crypt(this.gn.user.ClientId), roomid: this.gn.crypt(this._did) }, function (_dataToday) {
      _that.beaconstoday = _dataToday
      for (var d = 0; d < _that.beaconstoday.length; d++) {
        _that.beaconstoday[d].duration = _that.beaconstoday[d].timediff
        var org = _that.gn.Organisations.find(obj => {
          return obj.id === _that.beaconstoday[d].orgid
        })
        var _orgcolor;
        if (org == undefined) _orgcolor = '#0537f9';
        else _orgcolor = org.color;
        _that.beaconstoday[d].orgcolor = _orgcolor
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/clinicopenroom/clinicopenroom.ts